export default __webpack_public_path__ + "static/media/file.96b27afa.svg";